<script lang="ts">
    import "../scss/app.scss";
    import "../assets/scss/general.scss";
    import "bootstrap/dist/css/bootstrap.min.css";
    import "../assets/scss/color-schemes/default.scss";

    import { afterUpdate, onMount } from "svelte";
    import { page } from "$app/stores";
    import type { PageServerData } from "./$types";
    import { SvelteToast } from "@zerodevx/svelte-toast";
    import { ProgressBar } from "@prgm/sveltekit-progress-bar";

    export let data: PageServerData;
    const primaryColor = String(data?.appreanceConfig?.data?.colors?.primary);

    function initializeJQuery() {
        const jquery = document.createElement("script");
        jquery.src = "/js/jquery-3.6.0.min.js";
        jquery.async = false;
        document.head.appendChild(jquery);

        const thirdParty = document.createElement("script");
        thirdParty.src = "/js/wordbench-third-party-scripts.min.js";
        thirdParty.async = false;
        document.head.appendChild(thirdParty);

        const wordbench = document.createElement("script");
        wordbench.src = "/js/wordbench-scripts.js";
        wordbench.async = false;
        document.head.appendChild(wordbench);
    }

    function initializefacebookShare() {
        const facebbokPlugin = document.createElement("script");
        facebbokPlugin.defer = true;
        facebbokPlugin.async = true;
        facebbokPlugin.nonce = "8cfWrwlz";
        facebbokPlugin.src = `https://connect.facebook.net/id_ID/sdk.js#xfbml=1&version=v18.0`;
        document.head.appendChild(facebbokPlugin);
    }

    onMount(() => {
        initializeJQuery();
        initializefacebookShare();

        if (
            $page.url.pathname.includes("stores") &&
            $page.url.pathname.includes("checkout")
        ) {
            return;
        } else {
            sessionStorage.removeItem("qty_prod");
        }
    });

    afterUpdate(() => {
        if (
            $page.url.pathname.includes("stores") &&
            $page.url.pathname.includes("checkout")
        ) {
            return;
        } else {
            sessionStorage.removeItem("qty_prod");
        }
    });
</script>

<main data-sveltekit-preload-data="hover">
    <ProgressBar color={primaryColor} />
    <slot />
    <div class="wrap">
        <SvelteToast target="new" options={{ intro: { y: -100 } }} />
    </div>
</main>

<style lang="css">
    main {
        font-family: Helvetica, Arial, Times, serif;
    }
    .wrap {
        --toastWidth: 100%;
        font-size: 0.875rem;
        --toastMinHeight: 2rem;
        --toastPadding: 0 0.5rem;
        --toastContainerTop: 1.15rem;
        --toastContainerRight: 0.5rem;
        --toastContainerBottom: auto;
        --toastContainerLeft: 0.5rem;
    }
    @media (min-width: 40rem) {
        .wrap {
            --toastWidth: 40rem;
            --toastContainerRight: auto;
            --toastContainerLeft: calc(50vw - 20rem);
        }
    }
</style>
